"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepCopy = exports.shallowCopy = void 0;
function shallowCopy(source) {
    return {
        ...source
    };
}
exports.shallowCopy = shallowCopy;
function deepCopy(source) {
    return JSON.parse(JSON.stringify(source));
}
exports.deepCopy = deepCopy;
